/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { GET_STATUS_REWARDS } from '../../actions/employees';

import { FAILURE, REQUEST, SUCCESS } from '../../actions/utils';

import { ICommonResponse, IDictionaryItem } from '../../api/types';

import genericReducers from '../genericReducer';

import { IReducers } from '..';

export type StatusRewardsState = ICommonResponse<IDictionaryItem>;

const initialState = {} as ICommonResponse<IDictionaryItem>;
const generic = genericReducers<StatusRewardsState>();
const statusRewards: IReducers<StatusRewardsState> = {
  [GET_STATUS_REWARDS[REQUEST]]: generic.get.request,
  [GET_STATUS_REWARDS[SUCCESS]]: generic.get.success,
  [GET_STATUS_REWARDS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, statusRewards);
